import {
    SET_MAPPING_STATUS,
    RESET_MAPPING_STATUS,
    FETCH_MAPPING_INFO,
    FAIL_FETCH_MAPPING_INFO,
    SUCCESS_FETCH_MAPPING_INFO,
    SET_MAPPING_INFO,
    FAIL_SET_MAPPING_INFO,
    SUCCESS_SET_MAPPING_INFO,
    DEL_MAPPING_INFO,
    FAIL_DEL_MAPPING_INFO,
    SUCCESS_DEL_MAPPING_INFO,
    RESET_PROCESS_ERROR
} from '../actions';

const initialState = {
    isFetching : false,
    error : false,
    isProcessError : false,
    templateValues : [],
    selectedTemplateValues : null,
    source : [],
    target : [],
    defaultTarget : [],
    templateInfo : [],
    templateName : '',
    templateID : null,
    isProcessComplete : false

};
export default function mappingSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case FETCH_MAPPING_INFO:
            Object.keys(initialState).forEach((keys)=>{
                ret[keys] = initialState[keys];
            });
            ret.isFetching = true;
            return ret;
        case FAIL_FETCH_MAPPING_INFO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_FETCH_MAPPING_INFO:
            ret = Object.assign({}, state, action.payload.data);
            ret.isFetching = false;
            return ret;
        case SET_MAPPING_INFO:
            ret.isFetching = true;
            return ret;
        case FAIL_SET_MAPPING_INFO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_SET_MAPPING_INFO:
            ret.isProcessComplete = true;
            ret.isFetching = false;
            return ret;
        case DEL_MAPPING_INFO:
            ret.isFetching = true;
            return ret;
        case FAIL_DEL_MAPPING_INFO:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_DEL_MAPPING_INFO:
            ret.isProcessComplete = true;
            ret.isFetching = false;
            return ret;
        case SET_MAPPING_STATUS:
            return Object.assign({}, state, action.payload);
        case RESET_MAPPING_STATUS:
            Object.keys(initialState).forEach((keys)=>{
                ret[keys] = initialState[keys];
            });
            return ret;
        case RESET_PROCESS_ERROR:
            ret.isProcessError = false;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/mapping.js